import type { SVGProps } from 'react'
const SvgCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    {...props}
  >
    <path d='M5.75 3A2.75 2.75 0 0 0 3 5.75v7.596c0 1.04.578 1.944 1.432 2.41.441.241.902-.147.902-.65 0-.349-.243-.644-.484-.895a1.242 1.242 0 0 1-.35-.865V5.75c0-.69.56-1.25 1.25-1.25h7.623c.335 0 .64.132.863.348.251.24.543.482.89.482.505 0 .897-.46.655-.902A2.743 2.743 0 0 0 13.373 3zM10 7a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3z' />
  </svg>
)
export default SvgCopy
